import { render, staticRenderFns } from "./Nuget.vue?vue&type=template&id=272e6ead&"
import script from "./Nuget.vue?vue&type=script&lang=js&"
export * from "./Nuget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports